export default "__VITE_ASSET__ymkEWFfE__"